import { NodeDefinition } from 'Automations/nodeDefinitions/types'
import { ReviewEditorNode } from '../review.editorNode'
import { ReviewIcon } from '../review.icon'
import { ReviewPlaceholderConfigForm } from './reviewPlaceholder.configForm'
import { handlesConnected, reviewTypeRequired } from '../review.validators'
import { Config } from './reviewPlaceholder.types'

export type { Config }

export const reviewPlaceholderNodeDefinition: NodeDefinition<Config> = {
  name: 'Review',
  editorNode: ReviewEditorNode,
  configForm: ReviewPlaceholderConfigForm,
  icon: ReviewIcon,
  defaultConfig: {
    name: '',
    reviewType: undefined
  },
  validation: {
    node: { ERROR: [], WARN: [] },
    config: {
      name: { ERROR: [], WARN: [] },
      reviewType: {
        ERROR: [reviewTypeRequired],
        WARN: []
      }
    },
    handles: { ERROR: [handlesConnected], WARN: [] }
  },
  handleMapping: () => ({
    APPROVED: 0,
    REJECTED: 1
  }),
  taskTransformer: () => []
}
